"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchResultConfig = useSearchResultConfig;
const React = require("react");
const app_1 = require("app");
const SearchResultTabService_1 = require("../../services/SearchResultTabService");
const index_1 = require("../index");
const constants_1 = require("../../constants");
function useSearchResultConfig(tabsConfig, configData, dictionary) {
    var _a;
    const { documentPreselectedLanguages, culture, isDocumentPage, algoliaAnalyticsTags } = configData;
    const typeFilterUrlKey = isDocumentPage ? constants_1.DOCUMENT_TYPE_KEY : constants_1.TAB_KEY;
    const [isHitsAndFiltersLoading, setIsHitsAndFiltersLoading] = React.useState(true);
    const [lastUserAction, setLastUserAction] = React.useState({
        name: app_1.LastUserActionNameEnum.Init,
    });
    const isSubsequentRef = React.useRef(false);
    const tabs = React.useMemo(() => SearchResultTabService_1.searchResultTabService.getTabsFromConfig(tabsConfig), [tabsConfig]);
    const preselectedTab = SearchResultTabService_1.searchResultTabService.getPreselectedTab(tabs, typeFilterUrlKey, isDocumentPage);
    React.useEffect(() => {
        if (!app_1.UrlService.GetQueryValueFromUrl(typeFilterUrlKey) && tabs.length > 0) {
            app_1.UrlService.AddToUrl({ key: typeFilterUrlKey, value: tabs[0].key });
        }
    }, [typeFilterUrlKey, tabs]);
    const [selectedTab, setSelectedTab] = React.useState(preselectedTab || tabs[0]);
    const initialUiState = React.useMemo(() => SearchResultTabService_1.searchResultTabService.getInitialUiState(selectedTab, documentPreselectedLanguages, culture), [selectedTab, documentPreselectedLanguages, culture]);
    const initialQuery = ((_a = initialUiState[selectedTab.key]) === null || _a === void 0 ? void 0 : _a.query) || '';
    const { query } = (0, index_1.useConfigQuery)(initialQuery, setLastUserAction);
    const { tabsResultCountMap, totalResultCount, isTabsLoading, isZeroResult, updateTabResultCount, } = (0, index_1.useTabResultCount)(tabs, documentPreselectedLanguages, culture, algoliaAnalyticsTags, query);
    React.useEffect(() => {
        if (!isTabsLoading && selectedTab && tabsResultCountMap[selectedTab.key] === 0) {
            const nextTabToSelect = tabs.find(tab => tabsResultCountMap[tab.key] > 0);
            nextTabToSelect && setSelectedTab(nextTabToSelect);
        }
    }, [tabsResultCountMap]);
    return React.useMemo(() => ({
        tabs,
        tabsResultCountMap,
        totalResultCount,
        selectedTab,
        setSelectedTab,
        updateTabResultCount,
        lastUserAction,
        setLastUserAction,
        initialUiState,
        dictionary,
        configData,
        query,
        isTabsLoading,
        isHitsAndFiltersLoading,
        isZeroResult,
        isSubsequentRef,
        setIsHitsAndFiltersLoading,
    }), [
        tabs,
        selectedTab,
        tabsResultCountMap,
        totalResultCount,
        updateTabResultCount,
        initialUiState,
        dictionary,
        configData,
        query,
        isTabsLoading,
        isZeroResult,
        isSubsequentRef,
        isHitsAndFiltersLoading,
        setIsHitsAndFiltersLoading,
        lastUserAction,
        setLastUserAction,
    ]);
}
